import {
  SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS,
  SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE,
  SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING,
  SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST,
  SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS,
} from '../../actionTypes';

export const fetchSmartEditGeoFilterStateRequest = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST,
  payload,
});

export const fetchSmartEditGeoFilterStateSuccess = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS,
  payload,
});

export const fetchSmartEditGeoFilterStateError = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE,
  payload,
});

export const fetchSmartEditGeoFilterStateLoading = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING,
  payload,
});

export const fetchSmartEditGeoFilterMarketRequest = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST,
  payload,
});

export const fetchSmartEditGeoFilterMarketSuccess = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS,
  payload,
});

export const fetchSmartEditGeoFilterMarketError = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE,
  payload,
});

export const fetchSmartEditGeoFilterMarketLoading = (payload: any) => ({
  type: SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING,
  payload,
});